"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLarixLockPool = exports.getLarixLockProgram = void 0;
const anchor_1 = require("@project-serum/anchor");
const config_1 = require("../config");
const getConncetion_1 = require("./getConncetion");
let program;
function getLarixLockProgram(connection, larixLockProgramId) {
    return __awaiter(this, void 0, void 0, function* () {
        if (program) {
            return program;
        }
        else {
            return program = new anchor_1.Program(config_1.LARIX_LOCK_IDL, larixLockProgramId, yield (0, getConncetion_1.getProvider)(connection));
        }
    });
}
exports.getLarixLockProgram = getLarixLockProgram;
let larixPool;
function getLarixLockPool(connection, larixLockProgramId, load = false) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!load && larixPool) {
            return larixPool;
        }
        else {
            const larixLockProgram = yield getLarixLockProgram(connection, larixLockProgramId);
            return larixPool = (yield larixLockProgram.account.lockPool.fetch(larixLockProgramId));
        }
    });
}
exports.getLarixLockPool = getLarixLockPool;
